export const getPaginationParams = (offset, limit) => {
  return `page=${offset ?? 1}&per_page=${limit ?? 0}`;
};
